import type { EnrollmentGoalPayload } from "api/services/admin/schemas";

export const NEW_ENROLLMENT_GOAL = -1 as const;

export const defaultValues: EnrollmentGoalPayload = {
  bonus_cents: 0,
  bonus_currency: "USD",
  enrollment_goal: 0,
};
